export type UserId = string
export type AccountId = string

export enum ACLRole {
  ADMIN = 'ADMIN',
  MANAGEMENT = 'MANAGEMENT',
  CLIENT = 'CLIENT',
}

export const isUser = (value: unknown): value is IUser => {
  return true
}

export interface IUser {
  id: UserId
  email: string
  firstName: string
  lastName: string
  password?: string
  registeredAt?: Date
  accessRole?: IAccessRole
}

export interface IAccount {
  id: AccountId
  name: string
  primaryCurrency: ICurrency
  totalDepositsValue?: number
  openedAt: Date
  updatedAt?: Date
  users?: IUser[]
  deposits?: IDeposit[]
}

export interface IAccessRole {
  id: number
  name: string
  codename: string
}

export interface ICurrency {
  id: string
  name: string
  code: string
  deposits: IDeposit[]
}

export interface IDeposit {
  id: string
  account: IAccount
  accountId: string
  amount: number
  currency: ICurrency
  currencyId: string
  realizedAt: Date
}

export interface IProfitShare {
  readonly id: string
  readonly profit: IProfit
  readonly profitId: string
  readonly account: IAccount
  readonly amount: number
  readonly realizedAt: string
  readonly currency?: ICurrency
  readonly currencyId?: string
}

export interface IProfit {
  readonly id: string
  readonly amount: number
  readonly currency: ICurrency
  readonly realizedAt: Date
  readonly shares: IProfitShare[]
}